export default "__VITE_ASSET__1ed29961__"